export default (field, operator, value) => {
    let val = value || null;
    if (operator.toLowerCase() === 'null' || operator.toLowerCase() === 'notnull') {
        val = null;
    } else if (operator.toLowerCase() === 'in' || operator.toLowerCase() === 'notin') {
        val = value;
    } else if(operator.toLowerCase() === 'contains' || operator.toLowerCase() === 'doesnotcontain') {
        val = value;
    } else if(operator.toLowerCase() === 'beginswith' || operator.toLowerCase() === 'doesnotbeginwith') {
        val = value;
    } else if(operator.toLowerCase() === 'endswith' || operator.toLowerCase() === 'doesnotendwith') {
        val = value;
    } else if (typeof value === 'boolean') {
        val = `${value}`.toUpperCase();
    }
    return val;
};